import { CheckCircle } from "lucide-react";

export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-blue-200/20 to-indigo-200/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="mb-6">
            </div>
            <h2 className="text-5xl font-bold mb-8 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent">
              Weekly Salad Subscription
            </h2>
            <p className="text-xl text-gray-700 mb-10 leading-relaxed">
              Founded with a passion for healthy living, we're committed to bringing you the freshest,
              most nutritious salads using locally sourced, organic ingredients.
            </p>
            <div className="space-y-6">
              <div className="group flex items-start space-x-4 p-4 rounded-2xl hover:bg-blue-50/50 transition-all duration-300 hover:shadow-lg">
                <div className="p-2 bg-blue-100 rounded-xl border border-blue-200 group-hover:bg-blue-200 group-hover:border-blue-300 transition-all duration-300">
                  <CheckCircle className="h-6 w-6 text-blue-600 flex-shrink-0 group-hover:scale-110 transition-transform duration-300" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-2 group-hover:text-blue-700 transition-colors">Built by nutritionists, enjoyed by food lovers</h4>
                  <p className="text-gray-600 group-hover:text-gray-700 transition-colors">Nutritiously designed by experts, crafted for your well-being</p>
                </div>
              </div>
              <div className="group flex items-start space-x-4 p-4 rounded-2xl hover:bg-indigo-50/50 transition-all duration-300 hover:shadow-lg">
                <div className="p-2 bg-indigo-100 rounded-xl border border-indigo-200 group-hover:bg-indigo-200 group-hover:border-indigo-300 transition-all duration-300">
                  <CheckCircle className="h-6 w-6 text-indigo-600 flex-shrink-0 group-hover:scale-110 transition-transform duration-300" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-2 group-hover:text-indigo-700 transition-colors">Strength In Every Bite</h4>
                  <p className="text-gray-600 group-hover:text-gray-700 transition-colors">Fuel your body with protein power</p>
                </div>
              </div>
              <div className="group flex items-start space-x-4 p-4 rounded-2xl hover:bg-purple-50/50 transition-all duration-300 hover:shadow-lg">
                <div className="p-2 bg-purple-100 rounded-xl border border-purple-200 group-hover:bg-purple-200 group-hover:border-purple-300 transition-all duration-300">
                  <CheckCircle className="h-6 w-6 text-purple-600 flex-shrink-0 group-hover:scale-110 transition-transform duration-300" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-2 group-hover:text-purple-700 transition-colors">Made Fresh Daily</h4>
                  <p className="text-gray-600 group-hover:text-gray-700 transition-colors">Every salad is prepared fresh to order with love and attention to detail</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-300/20 via-indigo-300/20 to-purple-300/20 rounded-3xl blur-2xl group-hover:blur-xl transition-all duration-500"></div>
            <div className="relative bg-white rounded-3xl p-8 border border-blue-100 shadow-2xl hover:shadow-3xl hover:border-blue-200 transition-all duration-500 hover:scale-105">
              <div className="overflow-hidden rounded-2xl">
                <img
                  src="/allsixsalad.JPG"
                  alt="Weekly Salad Subscription"
                  className="w-full h-120 object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
